// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import RelatedMapSvg from '@rsuite/icon-font/lib/charts/RelatedMap';
var RelatedMap = createSvgIcon({
  as: RelatedMapSvg,
  ariaLabel: 'related map',
  category: 'charts',
  displayName: 'RelatedMap'
});
export default RelatedMap;